module.exports = __webpack_public_path__ + "img/looking-for-user.33c47a4.gif";